var _rect, _rect2, _circle, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmbeddedFluorescenLineOutput({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Embedded Fluorescen Line Output") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "none"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.2,
    y: 5.48,
    width: 5.23,
    height: 4.82,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.15
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 2.77,
    cy: 7.84,
    r: 0.72,
    fill: "#fff",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.15
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 5.33,
    y: 5.48,
    width: 5.23,
    height: 4.82,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.15
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 10.57,
    y: 5.48,
    width: 5.23,
    height: 4.82,
    fill: "none",
    stroke: "#fff",
    strokeMiterlimit: 10,
    strokeWidth: 0.15
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmbeddedFluorescenLineOutput);
export default __webpack_public_path__ + "static/media/EmbeddedFluorescenLineOutput.a211fc4ef3c203a809e8b1920adc67a0.svg";
export { ForwardRef as ReactComponent };